/* Stack Builder tweaks - moved to a theme asset (Claude, 26 Aug 2026).
   The inline <script> copy in the section is being neutralised for some
   visitors (guest sessions rendered dead grids on all three stores), while
   same-origin asset scripts run fine site-wide. This file restores the
   builder; it is GUARDED to no-op when the inline copy already executed,
   so nothing runs twice. Loaded with defer from sections/stack-builder-overrides.liquid. */
if (document.getElementById('csb-presets')) {
(function(){
  /* real variant ids + per-length prices per chain/metal (US store, fetched 26 Aug 2026).
     Lengths are inches. i = variant id, p = sale price, r = RRP. A missing
     length key means the variant does not exist on that product. */
  var CSB_VAR = {
    s: {
      cuban4:{20:{i:29698415132754,p:64.49,r:85.99},22:{i:29698415165522,p:64.49,r:85.99},24:{i:42502899105963,p:67.49,r:89.99},26:{i:42502900318379,p:67.49,r:89.99}},
      cuban6:{20:{i:44506120650923,p:71.24,r:94.99},22:{i:44506120683691,p:71.24,r:94.99},24:{i:44506120716459,p:74.24,r:98.99},26:{i:44506120749227,p:74.24,r:98.99}},
      cuban8:{20:{i:29698406416466,p:77.99,r:103.99},22:{i:29698406449234,p:77.99,r:103.99},24:{i:44429500448939,p:80.99,r:107.99},26:{i:44429500481707,p:80.99,r:107.99}},
      cuban12:{20:{i:29698404876370,p:84.74,r:112.99},22:{i:29698404909138,p:84.74,r:112.99},24:{i:44429514014891,p:87.74,r:116.99}},
      rope3:{20:{i:29698398126162,p:42.74,r:56.99},22:{i:29698398158930,p:42.74,r:56.99},24:{i:32424219246674,p:44.24,r:58.99},26:{i:42502872170667,p:44.24,r:58.99}},
      rope5:{20:{i:29698394947666,p:45.74,r:60.99},22:{i:29698394980434,p:45.74,r:60.99},24:{i:32424220983378,p:47.24,r:62.99},26:{i:42502877675691,p:47.24,r:62.99}},
      wheat3:{20:{i:29698474049618,p:42.74,r:56.99},22:{i:29698474082386,p:42.74,r:56.99},24:{i:39634378686635,p:44.24,r:58.99},26:{i:42502883442859,p:44.24,r:58.99}},
      wheat5:{20:{i:29698464677970,p:45.74,r:60.99},22:{i:29698464710738,p:45.74,r:60.99},24:{i:42502888161451,p:47.24,r:62.99},26:{i:42502888718507,p:47.24,r:62.99}},
      figaro3:{20:{i:29698504458322,p:42.74,r:56.99},22:{i:29698504491090,p:42.74,r:56.99},24:{i:39634371903659,p:44.24,r:58.99},26:{i:42502836682923,p:44.24,r:58.99}},
      figaro5:{20:{i:29698501509202,p:45.74,r:60.99},22:{i:29698501541970,p:45.74,r:60.99},24:{i:42502854377643,p:47.24,r:62.99},26:{i:42502855786667,p:47.24,r:62.99}},
      connell2:{20:{i:32424252047442,p:42.74,r:56.99},22:{i:32424252080210,p:44.24,r:58.99},24:{i:39634365120683,p:44.99,r:59.99},26:{i:42363303002283,p:46.49,r:61.99}}
    },
    g: {
      cuban4:{20:{i:29688987779154,p:67.49,r:89.99},22:{i:29688987877458,p:67.49,r:89.99},24:{i:42502896091307,p:71.24,r:94.99},26:{i:42502897598635,p:71.24,r:94.99}},
      cuban6:{20:{i:44506102530219,p:74.24,r:98.99},22:{i:44506102562987,p:74.24,r:98.99},24:{i:44506102595755,p:77.99,r:103.99},26:{i:44506102628523,p:77.99,r:103.99}},
      cuban8:{20:{i:29698287992914,p:80.99,r:107.99},22:{i:29698288025682,p:80.99,r:107.99},24:{i:44429491962027,p:84.74,r:112.99},26:{i:44429491994795,p:84.74,r:112.99}},
      cuban12:{20:{i:29698304344146,p:87.74,r:116.99},22:{i:29698304376914,p:87.74,r:116.99},24:{i:44429508837547,p:91.49,r:121.99}},
      rope3:{20:{i:29698308866130,p:44.24,r:58.99},22:{i:29698308898898,p:44.24,r:58.99},24:{i:32424210595922,p:45.74,r:60.99},26:{i:42502868828331,p:45.74,r:60.99}},
      rope5:{20:{i:29698382725202,p:47.24,r:62.99},22:{i:29698382757970,p:47.24,r:62.99},24:{i:32424214069330,p:49.49,r:65.99},26:{i:42502875938987,p:49.49,r:65.99}},
      wheat3:{20:{i:29698431615058,p:44.24,r:58.99},22:{i:29698431647826,p:44.24,r:58.99},24:{i:39634376523947,p:45.74,r:60.99},26:{i:42502882427051,p:45.74,r:60.99}},
      wheat5:{20:{i:29698460450898,p:47.24,r:62.99},22:{i:29698460483666,p:47.24,r:62.99},24:{i:42502886031531,p:49.49,r:65.99},26:{i:42502886850731,p:49.49,r:65.99}},
      figaro3:{20:{i:29698493841490,p:44.24,r:58.99},22:{i:29698493874258,p:44.24,r:58.99},24:{i:39634370265259,p:45.74,r:60.99},26:{i:42502833012907,p:45.74,r:60.99}},
      figaro5:{20:{i:29698499641426,p:47.24,r:62.99},22:{i:29698499674194,p:47.24,r:62.99},24:{i:42502840877227,p:49.49,r:65.99},26:{i:42502853853355,p:49.49,r:65.99}},
      connell2:{20:{i:32417686618194,p:44.24,r:58.99},22:{i:32417686650962,p:44.99,r:59.99},24:{i:39634367479979,p:46.49,r:61.99},26:{i:42363297235115,p:47.99,r:63.99}}
    }
  };


  /* one image-map correction over the main section's copy */
  STACK_IMG.g['wheat3|figaro5'] = '3mm-wheat-chain-50-5mm-figaro-chain-55-set-gold-ecom-1_31d857ff-dd64-47a0-9372-3d0e99cb64c5.jpg?v=1761045678';

  /* live availability map rendered by Liquid into #csb-stock. Fails OPEN:
     a variant missing from the map is treated as in stock, so a collection
     hiccup can never block purchases. */
  var CSB_STOCK = {};
  try { CSB_STOCK = JSON.parse(document.getElementById('csb-stock').getAttribute('data-stock')) || {}; } catch(e){}
  /* 1 = available, 2 = out of stock, 0 = not made in this length */
  function csbOk(metal, id, len){
    var e = (CSB_VAR[metal][id]||{})[len];
    if (!e) return 0;
    var vid = (typeof e === 'object') ? e.i : e;
    return CSB_STOCK[vid] === 0 ? 2 : 1;
  }

  /* set-level discount rate baked into displayed prices. 0 = none (chain
     Stack & Save deactivated 26 Aug 2026). */
  var CSB_STACK_RATE = 0;
  function csbNet(p){ return Math.round(p * (1 - CSB_STACK_RATE) * 100) / 100; }

  /* price lookup at a given length, falling back to the chain's base price */
  function csbAt(metal, id, len){
    var e = (CSB_VAR[metal][id]||{})[len];
    if (e) return {p:e.p, r:e.r};
    var c = csbById(id);
    return {p:c.price, r:c.rrp};
  }

  CSB_MAXSAVE = (function(){
    var m = 0;
    ['s','g'].forEach(function(mt){
      CSB_CHAINS.forEach(function(x){ CSB_CHAINS.forEach(function(y){
        CSB_LENGTHS.forEach(function(l){
          var L1 = l.id.slice(0,2), L2 = l.id.slice(2);
          var a = csbAt(mt, x.id, +L1), b = csbAt(mt, y.id, +L2);
          var s = (a.r - csbNet(a.p)) + (b.r - csbNet(b.p));
          if (s > m) m = s;
        });
      });});
    });
    return Math.floor(m);
  })();

  /* cheapest-first picker order; Rope 3mm leads (US cheapest) */
  var CSB_ORDER = ['rope3','wheat3','figaro3','connell2','rope5','wheat5','figaro5','cuban4','cuban6','cuban8','cuban12'];
  CSB_CHAINS.sort(function(a,b){ return CSB_ORDER.indexOf(a.id) - CSB_ORDER.indexOf(b.id); });

  /* default stack = cheapest (Rope 3mm + Rope 3mm); deep links override */
  csbState.c1 = 'rope3';
  csbState.c2 = 'rope3';
  try {
    var q = new URLSearchParams(location.search);
    if (q.get('metal')==='g' || q.get('metal')==='gold') csbState.metal='g';
    if (q.get('c1') && csbById(q.get('c1'))) csbState.c1 = q.get('c1');
    if (q.get('c2') && csbById(q.get('c2'))) csbState.c2 = q.get('c2');
    if (q.get('len') && CSB_LENGTHS.some(function(l){return l.id===q.get('len')})) csbState.length = q.get('len');
  } catch(e){}

  /* if the opening pick is unavailable at the current length, open on the
     first available (cheapest) chain instead; deep-linked picks are left
     alone so shared links show their true state */
  (function(){
    var q2 = null;
    try { q2 = new URLSearchParams(location.search); } catch(e){}
    var L0 = csbLens();
    [['c1', L0[0]], ['c2', L0[1]]].forEach(function(sl){
      if (q2 && q2.get(sl[0])) return;
      if (csbOk(csbState.metal, csbState[sl[0]], sl[1]) === 1) return;
      var alt = CSB_CHAINS.filter(function(c){ return csbOk(csbState.metal, c.id, sl[1]) === 1; })[0];
      if (alt) csbState[sl[0]] = alt.id;
    });
  })();

  function csbLens(){ return [csbState.length.slice(0,2), csbState.length.slice(2)]; }
  function csbVars(){
    var L = csbLens();
    var a = (CSB_VAR[csbState.metal][csbState.c1]||{})[+L[0]];
    var b = (CSB_VAR[csbState.metal][csbState.c2]||{})[+L[1]];
    return [ a && a.i, b && b.i ];
  }
  function csbAtcButtons(){ return document.querySelectorAll('#csb-root .csb-cta, #csb-root .csb-mobilebar button'); }
  function csbSetAtc(text, disabled){
    csbAtcButtons().forEach(function(b){ b.textContent = text; b.disabled = !!disabled; });
  }

  window.csbATC = function(){
    var v = csbVars();
    if (!v[0] || !v[1]) return;
    var a=csbById(csbState.c1), b=csbById(csbState.c2), L=csbLens();
    var key = a.name+' + '+b.name+' ('+(csbState.metal==='s'?'Silver':'Gold')+', '+L[0]+'+'+L[1]+'in)';
    csbSetAtc('Adding…', true);
    fetch('/cart/add.js', {
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body: JSON.stringify({items:[
        {id:v[0], quantity:1, properties:{'Stack':key}},
        {id:v[1], quantity:1, properties:{'Stack':key}}
      ]})
    }).then(function(r){
      if (!r.ok) throw new Error('add failed');
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));
      var d = document.getElementById('cart-drawer');
      if (d) {
        setTimeout(function(){ d.setAttribute('open',''); csbSync(); }, 700);
      } else {
        window.location.href = '/cart';
      }
    }).catch(function(){
      csbSetAtc('Out of stock — try another combo', false);
      setTimeout(function(){ csbSync(); }, 2500);
    });
  };

  function csbSync(){
    var L = csbLens();
    var s1 = csbOk(csbState.metal, csbState.c1, L[0]);
    var s2 = csbOk(csbState.metal, csbState.c2, L[1]);
    if (!s1 || !s2) { csbSetAtc('Unavailable in this length — try 20 + 22″', true); }
    else if (s1 === 2 || s2 === 2) { csbSetAtc('Out of stock in this length — pick another chain', true); }
    else { csbSetAtc('Add stack to bag', false); }
  }

  /* 1. remove the Proven Stack step */
  var _pr = document.getElementById('csb-presets');
  if (_pr) { var _st = _pr.closest('.csb-step'); if (_st) _st.remove(); }

  /* 2. swipe arrows on the two chain pickers (mobile) */
  ['grid1','grid2'].forEach(function(gid){
    var g = document.getElementById(gid);
    if (!g) return;
    var head = g.closest('.csb-step').querySelector('.csb-stephead');
    var nav = document.createElement('span');
    nav.className = 'csb-swipenav';
    nav.innerHTML = '<button type="button" aria-label="Scroll back" onclick="document.getElementById(\''+gid+'\').scrollBy({left:-264,behavior:\'smooth\'})">&lsaquo;</button>'+
                    '<button type="button" aria-label="Scroll forward" onclick="document.getElementById(\''+gid+'\').scrollBy({left:264,behavior:\'smooth\'})">&rsaquo;</button>';
    head.appendChild(nav);
  });

  /* 3. saving chip inside the sticky bar */
  var _mbp = document.querySelector('.csb-mobilebar .p');
  if (_mbp) {
    var row = document.createElement('div');
    while (_mbp.firstChild) row.appendChild(_mbp.firstChild);
    _mbp.appendChild(row);
    var sv = document.createElement('span');
    sv.className = 'csb-mb-save'; sv.id = 'mb-save';
    _mbp.appendChild(sv);
  }

  /* 4. stack thumbnail in the buy box - tap to jump back to the big preview */
  var _bb = document.getElementById('csb-buybox');
  if (_bb) {
    var bbTop = document.createElement('div'); bbTop.className = 'csb-bb-top';
    var th = document.createElement('div'); th.className = 'csb-bb-thumb';
    th.innerHTML = '<img id="bb-thumb" alt="Your stack"><span>See your stack</span>';
    th.onclick = function(){ document.querySelector('.csb-stage').scrollIntoView({behavior:'smooth', block:'center'}); };
    var info = document.createElement('div'); info.className = 'csb-bb-info';
    info.appendChild(_bb.querySelector('.csb-bb-head'));
    info.appendChild(_bb.querySelector('.csb-bb-title'));
    info.appendChild(_bb.querySelector('.csb-bb-price'));
    bbTop.appendChild(th); bbTop.appendChild(info);
    _bb.insertBefore(bbTop, _bb.firstChild);
  }

  /* 4b. length chip overlaid on the stack preview */
  var _shot = document.querySelector('#csb-root .csb-shot');
  if (_shot && !document.getElementById('csb-lenchip')) {
    var _lc = document.createElement('span');
    _lc.id = 'csb-lenchip';
    _shot.appendChild(_lc);
  }

  /* 5. relabel the saving row + What's included under both ATCs */
  var _ssRow = document.getElementById('stackSave');
  if (_ssRow) {
    var lbl = _ssRow.parentElement.querySelector('.n');
    if (lbl) lbl.textContent = 'Total saving vs RRP';
  }
  document.querySelectorAll('#csb-root .csb-sbody .csb-cta, #csb-root .csb-buybox .csb-cta').forEach(function(btn){
    var inc = document.createElement('div');
    inc.className = 'csb-inc';
    inc.innerHTML = '<b>What’s included</b><ul class="csb-inc-list"></ul>';
    btn.insertAdjacentElement('afterend', inc);
  });

  /* 6. wire every ATC button to the real cart */
  csbAtcButtons().forEach(function(b){ b.onclick = window.csbATC; });

  /* 6c. re-dispatch pickers through the overridable global render (the asset
     copy of the main script is block-scoped, so its internal csbRender
     reference would otherwise bypass the override below) */
  window.csbSetMetal = function(m){ csbState.metal=m; window.csbRender(); };
  window.csbSetLength = function(id){ csbState.length=id; window.csbRender(); };
  window.csbPick = function(slot,id){ if(slot===1){ csbState.c1=id; } else { csbState.c2=id; } window.csbRender(); };
  window.csbPreset = function(a,b){ csbState.c1=a; csbState.c2=b; window.csbRender(); window.scrollTo({top:0,behavior:'smooth'}); };

  /* 7. per-length card prices: slot 1 prices at the first length, slot 2 at the second */
  csbChainCard = function(c,slot,selected){
    var L = csbLens();
    var len = +(slot===1 ? L[0] : L[1]);
    var px = csbAt(csbState.metal, c.id, len);
    var st = csbOk(csbState.metal, c.id, len);
    var csbBadge = st===1 ? (c.top ? '<span class="csb-badge">Best seller</span>' : (c.top2 && slot===2 ? '<span class="csb-badge csb-red">Top pick</span>' : ''))
      : '<span class="csb-badge csb-oosbadge">'+(st===0?'Not in this length':'Out of stock')+'</span>';
    return '<div class="csb-card'+(selected?' on':'')+(st===1?'':(st===2?' csb-oos':' csb-oos csb-na'))+'"'+(st===1?' onclick="csbPick('+slot+',\''+c.id+'\')"':'')+'>'+csbBadge+
      '<span class="csb-tick">&#10003;</span><img loading="lazy" src="'+CSB_CDN+c.img[csbState.metal]+'" alt="'+c.name+'">'+
      '<div class="csb-cbody"><div class="csb-cname">'+c.name+'</div>'+
      '<div class="csb-cprice">'+csbGbp(csbNet(px.p))+'<s>'+csbGbp(px.r)+'</s>'+'</div></div></div>';
  };

  /* 8. charged-price framing, computed per metal + length + rerender covering the new elements (replaces main csbRender) */
  window.csbRender = function(){
    document.getElementById('mSilver').className = csbState.metal==='s'?'on':'';
    document.getElementById('mGold').className = csbState.metal==='g'?'on':'';
    document.getElementById('csb-lengths').innerHTML = CSB_LENGTHS.map(function(l){
      return '<div class="csb-lencard'+(csbState.length===l.id?' on':'')+'" onclick="csbSetLength(\''+l.id+'\')">'+
        (l.popular?'<span class="csb-badge">Most popular</span>':'')+'<b>'+l.label+'</b><span>'+l.note+'</span></div>';
    }).join('');
    document.getElementById('grid1').innerHTML = CSB_CHAINS.map(function(c){return csbChainCard(c,1,csbState.c1===c.id)}).join('');
    document.getElementById('grid2').innerHTML = CSB_CHAINS.map(function(c){return csbChainCard(c,2,csbState.c2===c.id)}).join('');

    var a=csbById(csbState.c1), b=csbById(csbState.c2);
    var len=CSB_LENGTHS.find(function(l){return l.id===csbState.length});
    var lens=csbLens();
    var pa=csbAt(csbState.metal, csbState.c1, +lens[0]), pb=csbAt(csbState.metal, csbState.c2, +lens[1]);
    var n1=csbNet(pa.p), n2=csbNet(pb.p);
    var total=Math.round((n1+n2)*100)/100, rrpTot=Math.round((pa.r+pb.r)*100)/100, save=Math.round((rrpTot-total)*100)/100;
    var metal = csbState.metal==='s'?'Silver':'Gold';
    var saveTxt = 'Save '+csbGbp(save);

    document.querySelector('.csb-savebar').innerHTML = 'Save up to <b>$'+CSB_MAXSAVE+'</b> off RRP on your stack';
    document.getElementById('stackimg').src = CSB_CDN + csbStackImg(csbState.c1, csbState.c2);
    var th2 = document.getElementById('bb-thumb');
    if (th2) th2.src = CSB_CDN + csbStackImg(csbState.c1, csbState.c2);
    document.getElementById('stackcap').textContent = a.name+' + '+b.name;
    var _lc2 = document.getElementById('csb-lenchip');
    if (_lc2) _lc2.textContent = lens[0]+' + '+lens[1]+'″';
    document.getElementById('n1l').textContent = a.name+' ('+metal+') · '+lens[0]+'"';
    document.getElementById('n2l').textContent = b.name+' ('+metal+') · '+lens[1]+'"';
    document.getElementById('p1').innerHTML = csbGbp(n1)+' <s style="color:var(--mid)">'+csbGbp(pa.r)+'</s>';
    document.getElementById('p2').innerHTML = csbGbp(n2)+' <s style="color:var(--mid)">'+csbGbp(pb.r)+'</s>';
    document.getElementById('stackSave').textContent = '−'+csbGbp(save);
    document.getElementById('csb-rrp').textContent = csbGbp(rrpTot);
    document.getElementById('total').textContent = csbGbp(total);
    document.getElementById('chip').textContent = saveTxt;
    document.getElementById('mrrp').textContent = csbGbp(rrpTot);
    document.getElementById('mtotal').textContent = ' '+csbGbp(total);
    var mbs = document.getElementById('mb-save');
    if (mbs) mbs.textContent = saveTxt;
    document.getElementById('bb-title').textContent = a.name+' + '+b.name+' ('+metal+') · '+lens[0]+' + '+lens[1]+'"';
    document.getElementById('bb-rrp').textContent = csbGbp(rrpTot);
    document.getElementById('bb-total').textContent = csbGbp(total);
    document.getElementById('bb-chip').textContent = saveTxt;
    document.querySelectorAll('.csb-inc-list').forEach(function(ul){
      ul.innerHTML = '<li>'+a.name+' ('+metal+') chain · '+lens[0]+'″</li>'+
        '<li>'+b.name+' ('+metal+') chain · '+lens[1]+'″</li>'+
        '<li>CRAFTD gift packaging</li>'+
        '<li>Lifetime Guarantee on both chains</li>';
    });
    csbSync();
  };
  csbRender();
})();
}
